import InputPhoneNumber from "./inputPhoneNumber";

export default InputPhoneNumber;